<template>
  <Modal modalId="downgrade-subscription-modal" size="modal-lg">
    <ModalHeader :title="$t('xDowngradeYourPlan')" icon="far fa-circle-dollar colorOrange mr-1">
      <div class="cols-auto">
        <button
          type="button"
          class="btn btn-icon-button btn-icon-button--gray"
          @click="closeModal('downgrade-subscription-modal')"
        >
          <i class="fas fa-times" />
        </button>
      </div>
    </ModalHeader>
    <ModalBody>
      <div v-if="currentSubscription && newSubscription" class="container" data-test-hook="downgrade-plan-modal-body">
        <b-row class="mb-3 text-center" no-gutters>
          <p class="downgrade-desc">
            {{
              $t('xDowngradingEffectDate', {
                0: $moment(currentSubscription.subscriptionRenewalDate).format($t('xShortDate'))
              })
            }}
          </p>
        </b-row>
        <b-row no-gutters>
          <b-col cols="6">
            <DowngradeSubscriptionCard
              :subscription-product="currentSubscription"
              :apparatuses-to-downgrade="currentApparatuses"
              :is-new-plan="false"
            />
          </b-col>
          <b-col cols="6">
            <DowngradeSubscriptionCard
              :subscription-product="newSubscription"
              :apparatuses-to-downgrade="currentApparatuses"
              :is-new-plan="true"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="text-center">
            <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
          </b-col>
        </b-row>
        <b-row no-gutters class="mt-3 align-items-center">
          <b-button
            variant="secondary"
            class="btn mr-3 flex flex-grow-1"
            style="width:48%"
            @click="closeModal('downgrade-subscription-modal')"
            data-test-hook="cancel-button"
          >
            {{ $t('xCancel') }}
          </b-button>
          <b-button
            variant="warning"
            style="width:48%"
            class="btn btn-primary flex flex-grow-1"
            @click="$emit('openPayment')"
            data-test-hook="downgrade-modal-button-continue"
          >
            {{ $t('xDowngradeNow') }}
          </b-button>
        </b-row>
      </div>
    </ModalBody>
  </Modal>
</template>

<script>
import DowngradeSubscriptionCard from './DowngradeSubscriptionCard.vue'

export default {
  props: ['currentSubscription', 'newSubscription'],
  emits: ['openPayment'],
  components: {
    DowngradeSubscriptionCard
  },
  data() {
    return {
      currentApparatuses: []
    }
  },
  mounted() {
    if (this.currentSubscription?.apparatuses) {
      this.currentApparatuses = this.currentSubscription.apparatuses
    }
  }
}
</script>
<style lang="scss">
.downgrade-desc {
  line-height: 1.4rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}

.legal-text {
  font-size: 0.875em;
  color: var(--gray-600);
}
</style>
